import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SupportUtils from "../../support/SupportUtils";
import ListPanelItem from "../../product/ListPanel/ListPanelItem/ListPanelItem";
import { ListPanelEntityModel } from "../../product/ListPanel/ListPanelModel";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";

import "./TagCategory.css";

const TagCategory: React.FC = () => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const { tag } = useParams();
  const { category } = useParams();

  const [data, setData] = useState<ListPanelEntityModel[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const tagToSearch = tag ? `#${tag}` : null;

  useEffect(() => {
    SupportUtils.getCachedOrStoryblokSearch(
      "",
      undefined,
      null,
      category,
      tagToSearch,
      "articles/"
    )
      .then((response: any) => {
        const data = (
          (response.data.story ||
            response?.data?.stories) as Array<ListPanelEntityModel>
        ).filter(
          (story) =>
            story?.full_slug?.startsWith("articles/news/") ||
            story?.full_slug?.startsWith("articles/faq/") ||
            story?.full_slug?.startsWith("articles/press/") ||
            story?.full_slug?.startsWith("articles/guest-editorial/")
        );
        setData(data);
      })
      .catch((error) => {
        if (error.status === 404) {
          navigate("/404");
        } else if (error.status === 500) {
          navigate("/500");
        }
      });
  }, [location, category, tagToSearch, navigate]);

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="tag-category-panel"
      style={{ backgroundColor: theme?.panelColour }}
    >
      <div className="tag-panel-container" style={{ color: theme?.textColor }}>
        <div className="title">
          <span>
            {tag ? "#" : ""}
            {category || tag} ARTICLES
          </span>
        </div>
        <div className={`list-panel-content three-items`}>
          {data
            ? data.map((entity) => {
                if (!entity || !entity.content) {
                  return null;
                }

                return (
                  <ListPanelItem
                    entity={entity}
                    containerColor={theme?.containerColor}
                    key={`tag-category-panel-${entity.uuid}`}
                  ></ListPanelItem>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default TagCategory;
